import { CheckIcon, ClipboardDocumentIcon } from '@heroicons/react/24/outline';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Markdown, Text, toast } from '@/shared/ui';

type CompletedChatViewProps = {
  completion: string;
  description?: string;
};

/**
 * 完了チャットビュー（AI回答表示）
 */
export const CompletedChatView: FC<CompletedChatViewProps> = ({ completion, description }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <CheckIcon className="h-[16px] w-[16px] text-primary" />
        <Text variant="description">{description ?? t('ai.analysis.completed')}</Text>
      </div>
      <div className="rounded-xl border border-border-base p-4">
        <Markdown>{completion}</Markdown>
      </div>
      <div className="flex justify-end gap-2">
        <Button
          variant="non-outline"
          size="none"
          className="w-[20px]"
          onClick={() => {
            navigator.clipboard.writeText(completion);
            toast.success(t('ai.analysis.copy-success'));
          }}
        >
          <ClipboardDocumentIcon className="size-2" />
        </Button>
      </div>
    </div>
  );
};
